<template>
  <div>
    <div class="container">
      <div class="processList">
        <TwTable
          :loading="loading"
          :cols="cols"
          :tableData="tableData"
          :editMode="editMode"
          :offsetY="300"
          autoHeight
          stripe
          @update-cell="updateCell"
          @update:tableData="updateTableData"
          @click-select-customer="openDialog"
          @click-delete-process="deleteProcess"
          @click-row="handleClickRow"
        />
      </div>
    </div>

    <el-dialog
      :title="$t('Label.Select Section')"
      class="header_border"
      :visible.sync="dialogSelectSection"
      :close-on-click-modal="false"
      width="617px"
      @close="onCloseDialog"
      :modal-append-to-body="false"
    >
      <template v-if="dialogSelectSection">
        <h2>{{ $t('Label.Select from History') }}</h2>
        <ul>
          <li
            v-for="section in sectionHistory"
            :key="`${section.tradingId}/${section.sectionId}`"
            @click="setSectionFromHistory(section)"
          >
            {{ section['en'] || section.label }}
          </li>
        </ul>
        <div v-if="!loadingSection">
          <tw-mcu-picker
            :section="section"
            :options="sections"
            placeholder="Company/Section"
            @input="setSection"
          />
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  defineComponent,
  ref,
  computed,
  onMounted,
} from '@vue/composition-api';
import {
  FROM_TO_TYPE,
  SECTION_PREFIX,
  PROCESS_CANCEL_FLG,
  PROCESS_PROGRESS_STATUS,
  DELETE_ABLE_FLG,
  ENTITY_TYPE,
  OTHER_TRADING_FLG,
  DETAIL_VIEWABLE_FLG,
} from 'lib-tw-common';
import { sectionForCascader, sectionForPulldown } from '@/utils/searchUtil';

// import sectionHistoryData from '@/sampleData/customer-section.json';
// import sample_dispatch_get_sections from '@/sampleData/dispatch_get_sections.json';

import TwMcuPicker from '@/components/molecules/TwMcuPicker';

import TwTable from '@/components/vue3/TwTable.vue';

export default defineComponent({
  name: 'DetailProcessFormTable',
  components: {
    TwTable,
    TwMcuPicker,
  },
  props: {
    cols: {
      type: Array,
      required: true,
    },
    tableData: {
      type: Array,
      default: null,
    },
    flowInfo: {
      type: Object,
      default: () => {},
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { root, emit }) {

    const loadingSection = ref(false);
    const targetProcess = ref(null);
    const section = ref([]);
    const sections = ref([]);
    const sectionDict = ref({});
    const dialogSelectSection = ref(false);
    const selectedSection = ref(null);
    const rowData = ref(null);
    const fromTo = ref('');
    const rowIndex = ref(null);

    // 履歴から選択
    const sectionHistory = computed(() => {

      if (!targetProcess.value) {
        return [];
      }

      const allHistory =
        root.$store.getters.getSectionHistory(targetProcess.value.processId) ||
        [];

      // const allHistory = sectionHistoryData;
      return _.filter(allHistory, history => {
        return _.find(sectionDict.value, { sectionId: history.sectionId });
      });
      // return [
      //   {
      //     value: 'LC00001036',
      //     label: 'Exporter1_forDevCS\nLC Section',
      //     tradingId: 'CO00000262',
      //     tradingName: 'Exporter1_forDevCS',
      //     tradingShortName: 'Exporter1_forDevCS',
      //     sectionId: 'LC00001036',
      //     sectionName: 'LC Section',
      //     sectionShortName: 'LC Section',
      //     en: 'Exporter1_forDevCS\nLC Section',
      //     local: 'Exporter1_forDevCS\nLC Section',
      //     tradingIcon: '/files/tw/companies/default/icon.png',
      //   },
      // ];
    });

    /* =====

      Methods

      ===== */

    // セクション情報を取得
    const fetchSections = async (query, fromTo) => {
      try {
        loadingSection.value = true;
        const res = await root.$store.dispatch('GET_SECTIONS', query);
        // const res = sample_dispatch_get_sections;
        sections.value = sectionForCascader(res.customerSectionList);
        sectionDict.value = sectionForPulldown(res.customerSectionList);
        section.value = [
          targetProcess.value[fromTo].companyId,
          targetProcess.value[fromTo].sectionId,
        ];
        dialogSelectSection.value = true;
        loadingSection.value = false;
      } catch (err) {
        root.$store.dispatch('SHOW_ALERT', err.message);
        loadingSection.value = false;
      }
      return;
    };

    const setOptions = (fieldKey, options) => {
      const field = props.cols.find(f => f.key === fieldKey);
      if (field && field.type === 'select') {
        field.options = options;
      }
    };

    const setSectionFromHistory = section => {
      selectedSection.value = [section.tradingId, section.sectionId];
      dialogSelectSection.value = false;
    };

    const selectSection = (process, fromTo) => {
      targetProcess.value = {
        ...process,
        fromTo,
        flowUuid: props.flowInfo.flowUuid,
        tradingFlowId: props.flowInfo.tradingFlowId,
      };

      // TODO 取引管理のレスポンスのprocessListからプルダウンを作成
      const query = {
        companyRoleCd: process[`${fromTo}RoleId`] || null,
        entityType: process.entityTypeCd,
        processId: process.processId,
        fromToFlg: fromTo === 'from' ? FROM_TO_TYPE.FROM : FROM_TO_TYPE.TO,
        deleteType: 0,
        // FY2022V2PH6-14 フロー編集時、プロセス追加する際の選択可能な会社がOwner縛りになっている
        // ownerCompanyId: _.get(this.s, 'tradingInfo.tradingPatternInfo.ownerCompanyId')
      };
      fetchSections(query, fromTo);
    };

    const setSection = value => {
      selectedSection.value = value;
      dialogSelectSection.value = false;
    };

    const onCloseDialog = () => {
      const value = selectedSection.value;

      if (!value) {
        return false;
      }

      let section = {
        tradingId: null,
        tradingName: null,
        tradingShortName: null,
        sectionId: null,
        sectionName: null,
        sectionShortName: null,
      };

      if (value && value[1]) {
        const targetSection = _.find(sectionDict.value, { value: value[1] });

        if (targetSection) {
          updateCell({
            prop: fromTo.value,
            row: rowData.value,
            rowIndex: rowIndex.value,
            value: targetSection,
          });
          // root.$store.commit('SET_SECTION_HISTORY', {processId: this.targetProcess.processId, section: targetSection});
          section = targetSection;
        }
      }

      // emit('set-process', { section, targetProcess, this.index });
      root.$nextTick(() => {
        // this.section = null;
        // this.targetProcess = null;
        // this.value = null;
        // this.sectionDict = [];
        // this.sections= [];
      });
    };

    // プロセスを更新します
    const updateCell = data => {
      emit('update-prop', data);
    };

    const handleClickRow = rowData => {
      if (
        !props.editMode &&
        rowData.detailViewableFlg !== DETAIL_VIEWABLE_FLG.OFF
      ) {
        const path = `/process/${_.toLower(rowData.processId)}/${rowData.entityId}/${rowData.processSeq}`;
        root.$router.push(path);
      }
    };

    const openDialog = ({ flowSide = 'from', row, index }) => {
      dialogSelectSection.value = true;
      fromTo.value = flowSide;
      targetProcess.value = row;
      rowIndex.value = index;
      rowData.value = row;

      // targetProcess.value = {
      //   ...process,
      //   flowSide,
      //   flowUuid: flowInfo.flowUuid,
      // };

      // TODO matsunaga
      // もともとのcompanyRoleCdは下記でisSavePatternがtrueのみだったので変えたが問題ないか
      // companyRoleCd: this.isSavePattern ? process[`${fromTo}RoleId`] || null : null,
      const query = {
        companyRoleCd: `${flowSide}RoleId` || null,
        entityType: row.entityTypeCd,
        processId: row.processId,
        fromToFlg: flowSide === 'from' ? FROM_TO_TYPE.FROM : FROM_TO_TYPE.TO,
        deleteType: 0,
      };
      fetchSections(query, flowSide);
    };

    const deleteProcess = process => {
      emit('click-delete-process', process);
    };

    const updateTableData = data => {
      // console.log('updateTableData=============', data);
    };

    onMounted(() => {
      // fetchSections()
      setOptions('from', sectionHistory);
      setOptions('to', sectionHistory);
    });

    return {
      loadingSection,
      dialogSelectSection,
      sectionHistory,
      sections,
      sectionDict,
      section,
      fetchSections,
      setSection,
      selectSection,
      handleClickRow,
      onCloseDialog,
      setSectionFromHistory,
      updateCell,
      openDialog,
      deleteProcess,
      updateTableData,
    };
  },
});
</script>

<style lang="scss" scoped>
.partial {
  padding: 9px 16px;
}

ul,
li {
  list-style: none;
}

ul {
  border-bottom: 1px solid $color_gray_300;
  margin-bottom: 24px;
  padding: 0;
}

li {
  margin: 0 0 24px;
  padding: 0;
  font-size: 16px;
  line-height: 24px;
  color: $color_dark_blue;
  cursor: pointer;
}

h2 {
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  margin: 0 0 24px;
}
</style>
